import { Component, OnInit } from '@angular/core';
import { AppComponent } from '../app.component';
import { ApiRestService } from '../services/api-rest.service';

@Component({
  selector: 'app-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.css']
})
export class TermsConditionsComponent implements OnInit {
  urlGeoApi:string;
  loadGeoApi=true;
  country:string;
  partner:string;

  constructor(
  		private appComponent: AppComponent,
  		private apiRestService: ApiRestService,
  	) {
  		this.partner = this.appComponent.config.partner;

  	}

	ngOnInit(): void {
		var vthis = this;
		this.urlGeoApi = "https://partnerapi.virtualsoft.tech"+'/GeoApi/GeoApi2';

      this.apiRestService.requestCustom(this.urlGeoApi , {partner: this.partner}).subscribe((response2: any) => {
        console.log(response2.countryCode.toLowerCase());
        if(response2 != undefined && response2.countryCode != undefined && response2.countryCode != '') {

          vthis.country = response2.countryCode.toLowerCase();
        }


      });
	}

	getURL() {
    return this.appComponent.config.urlApi.url;
  }

}
